import * as R from 'ramda'
/**
 *  Convert a list of strings into an English, Oxford-comma-separated list
 *  e.g. ['a', 'b', 'c'] becomes 'a, b, and c'
 */
export const toEnglishList = (list: string[]): string => {
  if (list.length === 1) {
    // ['a'] => 'a'
    return list[0]
  } else if (list.length === 2) {
    // ['a', 'b'] => 'a and b'
    return list[0] + ' and ' + list[1]
  } else if (list.length > 2) {
    // ['a', 'b', 'c', 'd'] => 'a, b, c, and d'
    return R.join(', ', list.slice(0, -1)) + ', and ' + list[list.length - 1]
  }
  // [] => ''
  return ''
}
